;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.State = Backbone.Model.extend({
		defaults: {
			id: '',
			state: ''
		}
	});

}(window, APP, Backbone, Marionette, $, _));